<template>
    <DxToolbar id="top-menu">
        <DxItem location="before">
            <a href="https://univeris.susu.ru" target="_blank">КИАС Универис</a>
        </DxItem>
        <DxItem location="before">
            <a href="https://www.univeris.susu.ru/page_data/personal-area/personal-area-staff/"
               target="_blank">Помощь</a>
        </DxItem>
        <DxItem location="after">
            Здравствуйте, {{ FriendlyName }}
        </DxItem>
    </DxToolbar>
    <DxToolbar class="toolbar">
        <DxItem location="before">
            <h2>Статистика приема</h2>
        </DxItem>
    </DxToolbar>
    <router-view></router-view>
</template>

<script>
import axios from '../plugins/axios'
import DxToolbar, {DxItem} from 'devextreme-vue/toolbar'
import {parseJwt} from '../plugins/common.js'
import ruMessages from 'devextreme/localization/messages/ru.json'
import {locale, loadMessages} from "devextreme/localization";
export default {
    name: "AppView",
    data() {
        return {
            openState: true,
            FriendlyName: "",
            menuButtonOptions: {
                icon: "menu",
                text: "Меню",
                onClick: () => {
                    this.openState = !this.openState;
                }
            },
            menuItems: [],

        };
    },
    components: {
        DxToolbar,
        DxItem,
    },
    created() {
        loadMessages(ruMessages);
        locale("ru-RU");
    },
    methods: {
        async authenticateUser() {
            var params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });
            var tokenId = params.tokenId;
            if (tokenId != null) {
                
                await axios("/AdmissionStatistics/GetFromRedis/" + tokenId).then(function (response) {
                    return response.data;
                }).then(data => {
                    localStorage.setItem('auth_token', data);
                    var jwtJson = parseJwt(data);
                    this.FriendlyName = jwtJson.FriendlyName
                    this.$router.push({path: '/', replace: true});
                });
            } else {
                if (process.env.VUE_APP_AUTHORIZE_NEEDED == "true") {
                    var data = localStorage.getItem('auth_token');
                    var jwtJson = parseJwt(data);
                    this.FriendlyName = jwtJson.FriendlyName;
                }
            }
        }
    },
    async mounted() {
        await this.authenticateUser();
    }
}

</script>